module.exports = __webpack_public_path__ + "media/images/icons/icons_large/33_invitation-89b53ee49afd239379907b26f5392999.png";